// extracted by mini-css-extract-plugin
module.exports = {"footerCont":"Footer_footerCont__WseZ6","topFooter":"Footer_topFooter__31vir","socialIcons":"Footer_socialIcons__1xJqE","bottomFooter":"Footer_bottomFooter__2l6-t"};